// import { FC } from 'react';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { Row, Col, Button, Typography } from 'antd';

export const PopupActionButtons = ({ femaleMode, onAction }) => {
	const buttonConfigs = [
		{
			action: 'select',
			label: `Marcar ${femaleMode ? 'todas' : 'todos'}`,
			icon: <CheckOutlined />,
			type: 'link',
			block: true,
		},
		{
			action: 'deselect',
			label: `Desmarcar ${femaleMode ? 'todas' : 'todos'}`,
			icon: <CloseOutlined />,
			type: 'link',
			block: true,
			danger: true,
		},
	];

	return (
		<Row>
			{buttonConfigs.map(({ action, label, icon, ...buttonProps }) => (
				<Col flex='1' key={action}>
					<Button
						onClick={() => onAction(action)}
						{...buttonProps}
					>
						<Typography.Text
							ellipsis={{ tooltip: { title: label, placement: 'right' } }}
							style={{ color: 'inherit' }}
						>
							{icon} {label}
						</Typography.Text>
					</Button>
				</Col>
			))}
		</Row>
	);
};
